@if (componentData | async; as data) {
  <div>
    <button type="button" class="btn cstm-btn-primary" [routerLink]="data.url">{{data.linkName}}</button>
  </div>
}